<template>
  <div class="buyer">
    <h6>Online-Bieter: {{onlineuser}}</h6>
    <h4>aktuelles Gebot: </h4><h1>{{ actgebot }}.- SFr.</h1>
    <h4>neues Gebot: </h4><h3>{{ newgebot }}.- SFr.</h3><br>
    <h2>{{ username }}</h2>
    {{ email }}<br>
    {{ adresse }}<br>
    {{ ort }}
    
  </div>
</template>

<script>

export default {
  name: 'buyer',
  data() {
    return {
    };
  },
  props: {
  },
  components: {},
  computed: {
    actgebot(){
        return this.$store.state.gebot.act
    },
    onlineuser(){
        return this.$store.state.onlineuser
    },
    newgebot(){
        return this.$store.state.gebot.new
    },
    username(){
      if (this.$store.state.gebot.saleuser != null){
        return this.$store.state.gebot.saleuser.vorname + " " + this.$store.state.gebot.saleuser.nachname
      }
      return ''
    },
    email(){
      if (this.$store.state.gebot.saleuser != null){
        return this.$store.state.gebot.saleuser.email
      }
      return ''
    },
    adresse(){
      if (this.$store.state.gebot.saleuser != null){
        return this.$store.state.gebot.saleuser.adresse + " " + this.$store.state.gebot.saleuser.nr
      }
      return ''
    },
    ort(){
      if (this.$store.state.gebot.saleuser != null){
        return this.$store.state.gebot.saleuser.plz + " " + this.$store.state.gebot.saleuser.ort
      }
      return ''
    }
  },
  
}
</script>

<style scoped>
@import '../../scss/classes.scss';

.buyer{
  margin: 50px;
  font-size: 50px;
}

h1{
    font-size: 80px;
    color: red;
  }
h2{
    font-size: 70px;
  }
h3{
    font-size: 50px;
  }


</style>
